<template>
  <div>
    <div class="row">
      <div class="col-sm-4 mb-2">
        <button
          class="btn btn-info btn-sm"
          @click="showModal('create')"
        >
          {{ $t('manage-question.create') }}
        </button>
      </div>
      <div class="col-sm-4 d-flex align-items-center justify-content-center mb-2">
        <small>{{ $t('pagination.show') }}</small>
        <select
          v-model="pagination.PageSize"
          class="form-control form-control-sm w-auto mx-2"
        >
          <option
            v-for="(size, s) in pageSizes"
            :key="s"
            :value="size"
          >
            {{ size }}
          </option>
        </select>
        <small>{{ $t('pagination.entries') }}</small>
      </div>
    </div>

    <data-table
      class="my-3"
      :fields="getFields($i18n.locale)"
      :data="questions"
    >
      <template #action="{ rowData }">
        <div class="d-flex justify-content-between">
          <a
            v-if="permission.permissions.includes('edit')"
            class="text-info mr-2"
            :title="rowData.id"
            @click="showModal('update', rowData.id)"
          >
            <img
              src="@/assets/icon/edit.png"
              alt="edit"
            >
          </a>
          <a
            v-if="permission.permissions.includes('delete')"
            class="text-info mr-2"
            :title="rowData.id"
            @click="showModal('delete', rowData.id)"
          >
            <img
              src="@/assets/icon/delete.png"
              alt="delete"
            >
          </a>
        </div>
      </template>
    </data-table>

    <div class="d-flex flex-wrap justify-content-center justify-content-sm-between">
      <div class="mb-2">
        <pagination-info
          :page="questions.currentPage"
          :page-size="questions.pageSize"
          :shown="questions.data.length"
          :total="questions.totalData"
        />
      </div>

      <pagination
        ref="pagination"
        class="mb-2"
        @change="onPageChange"
      />
    </div>

    <create-question
      v-if="modal.create"
      @close="closeModal"
    />

    <update-question
      v-if="modal.update"
      :id="modal.id"
      @close="closeModal"
    />

    <delete-question
      v-if="modal.delete"
      :id="modal.id"
      @close="closeModal"
    />
  </div>
</template>

<script>
import Api from '@/utils/Api'
import { PAGE_SIZES } from '@/fixtures'
import DataTable from '@/components/DataTable'
import PaginationInfo from '@/components/PaginationInfo'
import Pagination from '@/components/Pagination'
import CreateQuestion from '@/views/ManageQuestion/Question/Create'
import UpdateQuestion from '@/views/ManageQuestion/Question/Update'
import DeleteQuestion from '@/views/ManageQuestion/Question/Delete'

export default {
  components: {
    DataTable,
    PaginationInfo,
    Pagination,
    CreateQuestion,
    UpdateQuestion,
    DeleteQuestion
  },

  data: () => ({
    pagination: {
      Page: 1,
      PageSize: 10
    },
    questions: {
      data: []
    },
    modal: {
      id: '',
      create: false,
      update: false,
      delete: false
    },
    permission: {
      permissions: []
    },
    workLocationId: JSON.parse(localStorage.getItem('profile'))?.workLocationId || null,
    role: JSON.parse(localStorage.getItem('profile'))?.role?.name.toLowerCase() || null
  }),

  computed: {
    pageSizes: () => PAGE_SIZES
  },

  watch: {
    '$i18n.locale' () {
      this.getFields(this.$i18n.locale)
    },
    'pagination.PageSize' () {
      this.pagination.Page = 1
      this.fetch()
    }
  },

  created () {
    const dataLoc = JSON.parse(localStorage.getItem('profile'))
    const index = dataLoc.role.permissions.findIndex(element => element.category === 'question')
    this.permission = dataLoc.role.permissions[index]
    this.fetch()
  },

  methods: {
    onPageChange (page) {
      this.pagination.Page = page
      this.fetch()
    },
    getFields (locale) {
      if (locale === 'en') {
        return [
          { name: 'action', title: 'Action', dataClass: '__action' },
          { name: 'titleIdn', title: 'Question (ID)', dataClass: '__questionId' },
          { name: 'titleEng', title: 'Question (EN)', dataClass: '__questionEn' },
          { name: 'type', title: 'Question Type', dataClass: '__type' },
          { name: 'workLocationName', title: 'Work Location', dataClass: '__workLocation' }
        ]
      }
      if (locale === 'id') {
        return [
          { name: 'action', title: 'Tindakan', dataClass: '__action' },
          { name: 'titleIdn', title: 'Pertanyaan (ID)', dataClass: '__questionId' },
          { name: 'titleEng', title: 'Pertanyaan (EN)', dataClass: '__questionEn' },
          { name: 'type', title: 'Tipe Pertanyaan', dataClass: '__type' },
          { name: 'workLocationName', title: 'Lokasi Kerja', dataClass: '__workLocation' }
        ]
      }
    },
    async fetch () {
      const { data } = await Api.question.list({
        ...this.pagination,
        workLocationId: this.workLocationId,
        role: this.role
      })
      this.questions = data
      this.$refs.pagination.setPaginationData({
        total: data.totalData,
        per_page: data.pageSize,
        current_page: data.currentPage,
        last_page: data.totalPage
      })
    },
    showModal (modalName, id) {
      this.modal.id = id
      this.modal[modalName] = true
    },
    closeModal (modalName) {
      this.modal[modalName] = false
      this.fetch()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep(.__action) { min-width: 70px; max-width: 70px; }
::v-deep(.__questionId) { min-width: 300px; max-width: 300px; }
::v-deep(.__questionEn) { min-width: 300px; max-width: 300px; }
::v-deep(.__type) { min-width: 100px; max-width: 100px; }
</style>
